


























/* Created- 11 - Jun - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaFullDialog from "@/Ui-Components/Common/Container/ParticaFullDialog.vue";
import ParticaConfirmDialog from "@/Ui-Components/Common/ConfirmDialog/ParticaConfirmDialog.vue";

import { ParticaErrorData, ParticaConfirmConfig } from "../../Models/Components.model";
import { BreadcrumbItem } from "../../Models/Breadcrumb";
import { ParticaEvent, eParticaAction } from "../../Models/ParticaEvent";

@Component(
	{
		name: "ParticaView",
		components: {
			ParticaColumnContainer,
			ParticaRowContainer,
			ParticaFullDialog,
			ParticaError,
			ParticaConfirmDialog
		}
	})
export default class ParticaView extends Vue {
	@Prop() private errorinfo: ParticaErrorData;
	@Prop() private dialog: ParticaConfirmConfig;
	@Prop() private breadcrumbs: BreadcrumbItem[];

	private async eventHandler(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}
	private showHelp() {
		this.eventHandler({ action: eParticaAction.SHOW_HELP } as ParticaEvent);
	}
}
